import {Box, Typography} from '@mui/material';

import {
  getCulturalFitPillarOverlapSx,
  getCulturalFitPillarTabSx,
} from './workforceProfileCulturalFitAnalysisSectionSx';
import {WorkforceProfileCulturalFitPillarDescription} from '../../types/WorkforceProfileTypes';

export interface Props {
  pillar: WorkforceProfileCulturalFitPillarDescription;
  language: 'en' | 'de';
  isActive: boolean;
  onSelect: () => void;
}

export const WorkforceCulturalFitPillarTab = ({pillar, language, isActive, onSelect}: Props) => {
  const overlapPercent = pillar.overlap != null ? Math.round(pillar.overlap * 100) : null;

  return (
    <Box component='button' type='button' onClick={onSelect} sx={getCulturalFitPillarTabSx(isActive)}>
      {pillar.pillarTitle[language]}
      {overlapPercent != null && (
        <Typography component='span' sx={getCulturalFitPillarOverlapSx(isActive)}>
          {overlapPercent}%
        </Typography>
      )}
    </Box>
  );
};
